import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import Link from 'next/link'

import * as S from './styles'

const AdvancedInstallment: FC = memo(() => (
  <S.Wrapper>
    <Text size="heading4" weight="medium" color="var(--colors-neutral-text-contrast-default)">
      Quer ter acesso a {' '}
      <Text size="heading4" as="span" weight="medium" color="var(--colors-secondary-text-contrast)">
        boletos de antecipação de parcelas
      </Text>
      {' '} ou {' '}
      <Text size="heading4" as="span" weight="medium" color="var(--colors-secondary-text-contrast)">
        renegociar o seu contrato
      </Text>
      ?
    </Text>
    <Text size="heading4" weight="medium" color="var(--colors-neutral-text-contrast-default)">
      Fale diretamente com a nossa equipe de atendimento por meio do e-mail {' '}
      <Link href="mailto:suporte.pagamento@cashme.com.br">suporte.pagamento@cashme.com.br</Link>
      .
    </Text>
  </S.Wrapper>
))

AdvancedInstallment.displayName = 'AdvancedInstallment'

export default AdvancedInstallment
